//Date Wrapper
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// Redux
import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import AuthorizationErrorNotice from "./components/AuthorizationErrorNotice";
import CookieNotice from "./components/CookieNotice";
import ErrorBoundary from "./components/ErrorBoundary";
import { store, persistor } from "./redux/store";
import Router from "./router";
import ThemeProvider from "./theme";

function App() {
  // Keyed on the route so leaving a broken page clears the boundary's fallback.
  const location = useLocation();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
              <ErrorBoundary resetKey={location.pathname}>
                <Router />
              </ErrorBoundary>
              <AuthorizationErrorNotice />
              <CookieNotice />
            </LocalizationProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
